import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loc : {
        organization_name : '',
        organization_type : '',
        email : '',
        status : ''
    },
    selectedLogs : []
  
};

const locSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocationData(state, action) {
      state.loc = action.payload;
    },
    setSelectedLogs(state, action){
      state.selectedLogs = action.payload;
    }
  },
});

export const { setLocationData, setSelectedLogs } = locSlice.actions;

export const selectLoc = (state) => state.location;

export default locSlice.reducer;